module.exports = __webpack_public_path__ + "static/media/bg_neutrals.586b344a.png";